export enum OneTrustRGPDUE {
  email = 'email',
  name = 'name',
  surname1 = 'surname1',
  surname2 = 'surname2',
  phone = 'phone',
  documentNumber = 'documentNumber',
  remarks = 'remarks',
  nif = 'nif',
  nombre = 'nombre',
  apellido1 = 'apellido1',
  apellido2 = 'apelldio2',
  fecha_nacimiento = 'fecha_nacimiento',
  sexo = 'sexo',
  estado = 'estado',
  nombre_calle = 'nombre_calle',
  numero = 'numero',
  movil = 'movil',
  telefono = 'telefono',
  apellidos = 'apellidos',
  tema = 'tema',
  comentario = 'comentario'
}

export enum RGPDUERightSelectOptions {
  OPPOSITION = 'OPPOSITION',
  RECEIVE_INFO = 'RECEIVE_INFO',
  PORTABILITY = 'PORTABILITY',
  OTHER_RIGHT = 'OTHER_RIGHT'
}

export enum RGPDUEPolicyDestinationSelectOptions {
  PARTICULAR_USE = 'PARTICULAR_USE',
  COMPANY = 'COMPANY'
}
export interface RGPDUERightSelectionData {
  rightSelectedOption: RGPDUERightSelectOptions;
  otherRightSpecified?: string;
  origin?: string;
  destination?: string;
  policies?: RGPDUEPortabilityPolicies[];
}
export interface RGPDUEPortabilityPolicies {
  policyNumber: string;
  policyType: string;
}
